import { ConfiguratorOptions } from "@icc/shared/types";

export const initialOptions: ConfiguratorOptions = {
    type: 'window',
    preset: 'b2c',
    hidePricesInB2cConfigurator: false,
    userLevel: null,
    userName: '',
    languageCode: '',
    languageCodes: [],
    mode: 'loadAllDefaults',
    config: null,
    env: null,
    projectName: 'icc',
    dimensionUnit: 'mm',
    numberOfPlacesAfterDecimalSeparator: 0,
    filterAccessoriesByCategories: false,
    weightUnit: 'kg',
    logo: '',
    returnButton: 'ADD',
    stepDescriptionEnabled: false,
    stepsDescriptions: {},
    sketches: {
        inner: null,
        outer: null
    },
    translationsTimestamp: 0,
    browserLanguage: false,
    currencies: [],
};
